const state = {
  model: {},
  loading: false
}

const getters = {
  model: (state) => {
    return state.model;
  }
}

const actions = {
  init({commit}, data) {
    commit('INIT_APPLICATION', data);
  },

  fetch({commit}) {

  },

  update({commit}, data) {
    commit('UPDATE_APPLICATION', data);
  }
}

const mutations = {
  INIT_APPLICATION(state, data) {
    state.model = {};
  },

  UPDATE_APPLICATION(state, data) {
    console.log('update application', data);
    state.model = {...state.model, ...data};
  }
}

export const Application = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}